<template>
  <div class="introduceTop">
    <el-row class="introduce_hide">
      <el-col :span="8">
        <div class="login-logos">
          <!-- <img src="../../assets/img/img-logo.png" alt /> -->
        </div>
      </el-col>
      <el-col :span="8" class="menu_left_in">
        <el-menu :default-active="$route.path" router class="el-menu-demo_in" mode="horizontal">
          <el-menu-item index="/index">首页</el-menu-item>
          <el-menu-item index="/introduce">业务介绍</el-menu-item>
          <el-menu-item index="/consultation">资讯中心</el-menu-item>
          <el-menu-item index="/about">关于扬海</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="8">
        <div class="notice_btn_new">
          <el-button @click="repaymentCommon">我要还款 ⇀</el-button>
        </div>
      </el-col>
      <div>
        <el-dialog
          title="我要还款"
          :visible.sync="dialogVisible"
          :modal="false"
          width="25%"
          :before-close="handleClose"
        >
          <span>输入姓名、身份证号码进行查询债务信息</span>
          <el-form
            :model="form"
            class="form_box"
            :rules="rules"
            ref="ruleForm"
            v-if="!information"
            style="padding:20px"
          >
            <el-form-item label="姓名" :label-width="formLabelWidth" prop="names">
              <el-input v-model="form.names" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" :label-width="formLabelWidth" prop="carId">
              <el-input v-model="form.carId" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
              <el-input v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-row>
              <el-col :span="11">
                <el-form-item label="验证码" prop="verification" :label-width="formLabelWidth">
                  <el-input v-model="form.verification" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label>
                  <el-button v-show="verificationStatus" @click="handleClick">点击获取验证码</el-button>
                  <el-button v-show="!verificationStatus">
                    <span>{{timer}}</span>秒后重新获取
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-form-item :label-width="formLabelWidth">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm',form)">立即查询</el-button>
            </el-form-item>
          </el-form>
          <div v-else style="display: flex; flex-direction: column; align-items: center;">
            <img style="padding:20px" src="./../../assets/img/img-zanwu.png" alt />
            <span>无欠款信息</span>
            <el-button style="width:200px;margin:20px" @click="again">重新查询</el-button>
          </div>
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>
<script>
// import middleKey from "../components/middleKey.vue"; //中间件
import banner from "@/components/page/banner.vue"; //脚部
import axios from "axios";

export default {
  components: {
    banner
  },
  data() {
    const mobileValid = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    const carIdValid = (rule, value, callback) => {
      const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (value === "") {
        callback(new Error(" "));
      } else if (!p.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    const verificationValid = (rule, value, callback) => {
      const p = /^\d{6}$/;
      if (value === "") {
        callback(new Error(" "));
      } else if (!p.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      information: false,
      form: {
        names: "",
        carId: "",
        phone: "",
        verification: ""
      },
      formLabelWidth: "70px",
      rules: {
        names: [
          { required: true, message: " ", trigger: "change" },
          { min: 2, max: 15, message: " ", trigger: "change" }
        ],
        phone: [{ validator: mobileValid, required: true, trigger: "change" }],
        carId: [{ validator: carIdValid, required: true, trigger: "change" }],
        verification: [
          { validator: verificationValid, required: true, trigger: "change" }
        ]
      },
      verificationStatus: true, //通过v-show控制显示获取还是倒计时
      timer: 60 //定义初始时间为60s
    };
  },
  computed: {},
  watch: {
    $route: function(to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      console.info(to, from);
    }
  },
  methods: {
    async handleClick() {
      let that = this;
      //获取验证码
      if(this.form && !(!/^1[3456789]\d{9}$/.test(this.form.phone)) && /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.form.carId)){
      await axios({
        url:
          "/npl/website/getVerification?carId=" + this.form.carId + '&phone=' + this.form.phone,
          method: "GET",
          withCredentials: true
      })
        .then(function(res) {
          if (res.data.code == "0000" && res.data.data) {
            that.verificationStatus = false; //点击button改变v-show的状态
            that.timer = 60;
            let auth_timer = setInterval(() => {
              that.timer--; //递减时间
              if (that.timer <= 0) {
                that.verificationStatus = true; //60s时间结束还原v-show状态并清除定时器
                clearInterval(auth_timer);
              }
            }, 1000);
          } else {
            that.$message({
                  message: '验证码每天不能大于三次',
                  type: 'error'
                });
          }
        })
        .catch(function(error) {});
      }else{
        that.$message.error('请输入正确的身份证号和手机号!');
      }
    },

    // async handleClick() {
    //   console.info("1")
    //   // if(this.form && !(!/^1[3456789]\d{9}$/.test(this.form.phone)) && /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.form.carId)){
    //   if(1){
    //      await this.ajaxJson({
    //         // url: "/websiteManage/contentListss?carId=" + this.form.carId + '&phone=' + this.form.phone,
    //         url: "/websiteManage/contentListss?carId=421123199109266866&phone=15558001707",
    //         method: "GET",
    //         success: function(data) {
    //           if(data.code == '0000' && data.data == true){
    //             console.info(data.data==true,"2")
    //             this.verificationStatus = false; //点击button改变v-show的状态
    //             this.timer = 60;
    //             let auth_timer = setInterval(() => {
    //               console.info("3")
    //               this.timer--; //递减时间
    //               if (this.timer <= 0) {
    //                 console.info("4")
    //                 this.verificationStatus = true; //60s时间结束还原v-show状态并清除定时器
    //                 clearInterval(auth_timer);
    //               }
    //             }, 1000);
    //           }else{
    //             console.info("3")
    //             this.$message({
    //               message: '验证码每天不能大于三次',
    //               type: 'error'
    //             });

    //           }
    //         }
    //       });
    //   }else{
    //      this.$message.error('请输入正确的身份证号和手机号!');
    //   }

    // },
    handleClose() {
      let that = this;
      that.dialogVisible = false;
    },
    repaymentCommon() {
      let that = this;
      that.$router.push({
        name: "settlementCertificate",
        params: {}
      }); // 只能用 name
      // that.dialogVisible = true;
    },
    again() {
      let that = this;
      that.information = false;
    },
    // submitForm(formName, form) {
    //   let that = this;
    //   // that.ajaxJson({
    //   //               url: "/websiteManage/contentListss",
    //   //               data:{
    //   //                 carId: form.carId,
    //   //                 page:1,
    //   //                 size:10
    //   //               },
    //   //               success: function(data) {
    //   //                 if (data.code == "0000") {
    //   //                   // that.$router.push({path:'paymentDetail'}) // 只能用 name
    //   //                   that.$router.push({name:'paymentDetail',params:data}) // 只能用 name
    //   //                 }
    //   //               }
    //   //             });
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       that.ajaxJson({
    //         url: "/website/findInfoByCarId?carId=" + form.carId + '&verification=' + form.verification + '&phone=' + form.phone,
    //         method: "GET",
    //         // data:{
    //         //   type: 1
    //         // },
    //         success: function(data) {
    //           if (data.code == "0000" && data.data == 1) {
    //             that.ajaxJson({
    //               url: "/website/authClears",
    //               data: {
    //                 carId: form.carId,
    //                 // phone: form.phone,
    //                 page: 1,
    //                 size: 10
    //               },
    //               success: function(datas) {
    //                 if (datas.code == "0000") {
    //                   that.$router.push({
    //                     name: "paymentDetail",
    //                     params: datas
    //                   }); // 只能用 name
    //                 }
    //               }
    //             });
    //           } 
    //            if(data.code == "0000" && data.data == 2){
    //             that.information = true;
    //           }
    //            if(data.code == "0000" && data.data == 3){
    //             that.$message({
    //               message: '验证码已失效请重新获取',
    //               type: 'error'
    //             });
    //           }
    //            if(data.code == "0000" && data.data == 4){
    //             that.$message({
    //               message: '验证码有误请重新输入',
    //               type: 'error'
    //             });
    //           }
              
    //         }
    //       });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // }
  
      submitForm(formName, form) {
      let that = this;
      // that.ajaxJson({
      //               url: "/websiteManage/contentListss",
      //               data:{
      //                 carId: form.carId,
      //                 page:1,
      //                 size:10
      //               },
      //               success: function(data) {
      //                 if (data.code == "0000") {
      //                   // that.$router.push({path:'paymentDetail'}) // 只能用 name
      //                   that.$router.push({name:'paymentDetail',params:data}) // 只能用 name
      //                 }
      //               }
      //             });

          that.ajaxJson({
            url: "/website/findInfoByCarId?carId=" + form.carId + '&verification=' + form.phone + '&phone=' + form.phone,
            method: "GET",
            // data:{
            //   type: 1
            // },
            success: function(data) {
              if (data.code == "0000" && data.data == 1) {
                that.ajaxJson({
                  url: "/website/authClears",
                  data: {
                    carId: form.carId,
                    // phone: form.phone,
                    page: 1,
                    size: 10
                  },
                  success: function(datas) {
                    if (datas.code == "0000") {
                      that.$router.push({
                        name: "paymentDetail",
                        params: datas
                      }); // 只能用 name
                    }
                  }
                });
              } 
               if(data.code == "0000" && data.data == 2){
                that.information = true;
              }
               if(data.code == "0000" && data.data == 3){
                that.$message({
                  message: '验证码已失效请重新获取',
                  type: 'error'
                });
              }
               if(data.code == "0000" && data.data == 4){
                that.$message({
                  message: '验证码有误请重新输入',
                  type: 'error'
                });
              }
              

            }
          });
    }

  }
};
</script>
<style>
@media screen and (min-width: 300px) and (max-width: 480px) {
  /* .introduce_hide{
    display: none;
  }
  .index-introduce .banner-box{
  display: block!important; 
}*/
}
.form_box {
  padding: 20px;
}
.form_box input {
  width: 70%;
}
.index-introduce {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}
.introduceTop {
  height: 420px;
  background: url("./../../assets/img/yanghai_banner.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.introduceCer {
  background: #fff;
}
.introduceCer_box_con img {
  width: 520px;
}
.introduceCer_box_con .el-row {
  padding-bottom: 170px;
}
.introduceCer_box_con .span1 {
  font-size: 60px;
  color: #222222;
}

.introduceCer_box_con .el-row .span2 {
  font-size: 0.3rem !important;
  font-weight: bold;
  line-height: 60px;
}
.introduceCer_box_con .el-row .span3 {
  font-size: 45px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(34, 34, 34, 1);
  height: 85px;
  display: inline-block;
  line-height: 85px;
}
.introduceCer_box_con .el-row .span4 {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 1);
  line-height: 38px;
}
.introduceCer_box_top .span1 {
  font-size: 45px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(34, 34, 34, 1);
  line-height: 45px;
}
.introduceCer_box_top .span2 {
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
  padding: 15px 0 40px 0;
  display: inline-block;
}
.introduceCer_box_top_border {
  width: 350px;
  height: 1px;
  background: rgba(34, 34, 34, 1);
  margin-bottom: 100px;
}
.introduceCer_box {
  padding: 100px 0 0 260px;
}
.login-logos {
  text-align: center;
  padding: 45px 0 25px 80px;
  display: inline-block;
}
.login-logos img {
  background-size: cover;
  width: 314px;
  height: 50px;
  margin-bottom: 165px;
}
.menu_left_in .el-menu {
  border-right: none;
  background-color: transparent;
  padding-top: 45px;
}
.menu_left_in .el-menu .el-menu-item {
  color: #ffffff !important;
  /* width:480px; */
  /* height:110px; */
  /* padding-top: 20px; */
  font-size: 14px;
  /* padding-left: 60px!important; */
}
.el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
.menu_left_in .el-menu-item,
.el-submenu__title {
  font-size: 12px;
}
.menu_left_in .el-menu.el-menu--horizontal {
  border-bottom: none;
}
.notice_btn_new {
  position: absolute;
  top: 40px;
  right: 65px;
}
.notice_btn_new .el-button {
  background: transparent;
  color: #fff;
  width: 170px;
  height: 50px;
  border: 1px solid rgba(255, 255, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/page/comTop.vue